import { ApplicationConfig } from '@angular/core';
import { provideRouter, withRouterConfig, ExtraOptions, withComponentInputBinding } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { providePostHogErrorHandler } from './posthog-error-handler'; 

import { routes } from './app.routes';

const routerConfig: ExtraOptions = {
  onSameUrlNavigation: 'reload'
};

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes, withRouterConfig(routerConfig), withComponentInputBinding()), provideHttpClient(), providePostHogErrorHandler()]
};